import React from 'react'
import { useParams } from 'react-router-dom';
import { useStorDetailsByAdmin } from '../../../hooks/admin/store.admin';
import LoadingErrorState from '../../../components/ui/LoadingErrorState';
import StoreAdminDetailsCard from '../../../components/admin/stores/StoreAdminDetailsCard';
import Layout from '../../../components/layouts/Layout';

function StoreDetailsForAdminPage() {
    const { storeId} = useParams<{ storeId: string}>();
   const numericStoreId = storeId ? parseInt(storeId) : 0;
   const {data,isError,isLoading} = useStorDetailsByAdmin(numericStoreId);
  return (
    <Layout title={data?.languages[0].name??""} headline={data?.sector.languages[0].name??""}>
        <LoadingErrorState
        isError={isError}
        isLoading={isLoading}
        />
        {data && <StoreAdminDetailsCard store={data}/>}
    </Layout>
  )
}

export default StoreDetailsForAdminPage